module.exports = __webpack_public_path__ + "static/img/26.ad2e20c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/26.png
// module id = /B7i
// module chunks = 0